/* istanbul ignore file */

/**
 * DO NOT EDIT!
 * This file was autogenerated by npm script `localizations-codegen`.
 * Changes may cause incorrect behavior and will be lost when the file is regenerated.
 *
 * Run `npx localizations-codegen` to regenerate.
 */
import type { TranslationKey } from '../models/TranslationKey';

export type DefaultTranslations = Record<keyof typeof TranslationKey, string>;

export const defaultTranslations: DefaultTranslations = {
  All: 'All',
  Customer: 'Customer',
  DeliveryAddress: 'Delivery Address',
  DeliveryInformationTooltip: 'Address can be changed in "Delivery information" after placing the order',
  DeliveryMethod: 'Delivery Method',
  EveryCatalogue: 'Every catalogue',
  EverySecondCatalogue: 'Every second catalogue',
  EveryThirdCatalogue: 'Every third catalogue',
  For: 'For',
  Frequency: 'Frequency',
  HomeDelivery: 'Home Delivery',
  Myself: 'Myself',
  Name: 'Name',
  NewCustomer: 'New Customer',
  NewSubscription: 'New subscription',
  NextStep: 'Next step',
  PayNow: 'Pay Now',
  PaymentMethod: 'Payment Method',
  PleaseWait: 'Please Wait',
  PriceTooltip: 'The price for the future orders may differ based on the current catalogue price.',
  Product: 'Product',
  Save: 'Save',
  SelectCustomer: 'Select Customer',
  SelectFrequency: 'Select frequency',
  Subscribed: 'Subscribed',
  SubscriptionReview: 'Subscription Review',
  Surname: 'Surname',
  TermsAndConditions: 'By clicking on this checkbox you agree to ',
  TotalCostForThisPeriod: 'Total cost for this period',
};

export const translationsNamespace = 'subscription-wizard';
